const Breakthrough = require("./Breakthrough");
const CulturalHeritage = require("./CulturalHeritage");
const EfficientUpgrade = require("./EfficientUpgrade");
const EndowmentForTheArts = require("./EndowmentForTheArts");
const EngineeringGenius = require("./EngineeringGenius");
const Frugality = require("./Frugality");
const MilitaryBuildup = require("./MilitaryBuildup");
const Patriotism = require("./Patriotism");
const Reserves = require("./Reserves");
const RevolutionaryIdea = require("./RevolutionaryIdea");
const RichLand = require("./RichLand");
const Stockpile = require("./Stockpile");
const UrbanGrowth = require("./UrbanGrowth");

module.exports = {
    Breakthrough,
    CulturalHeritage,
    EfficientUpgrade,
    EndowmentForTheArts,
    EngineeringGenius,
    Frugality,
    MilitaryBuildup,
    Patriotism,
    Reserves,
    RevolutionaryIdea,
    RichLand,
    Stockpile,
    UrbanGrowth,
}